import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../../../Context/UserContextProvider';
import axios from "../../../../axios/index"

import ShowProfileModal from '../../DashboardFileManagement/CardDetail/ShowProfileModal';
import DashboardHeader from '../../DashboardReuseAbleComponents/DashboardHeader';
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import StaffMessageSendTo from './StaffMessageSendTo';
import StaffMessageForm from './StaffMessageForm';
import { sendGroupMessageValidate } from './sendGroupMessageValidate';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Styles
import styles from "./../StaffManagment.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const StaffMessage = () => {
    const { userToken } = useContext(UserContext);
    const [modalShow, setModalShow] = useState(false);
    const [errors, setErrors] = useState({});
    const history = useHistory();
    const [btnLoader, setBtnLoader] = useState(false)

    const [invitedPeople, setInvitedPeople] = useState([]);

    const [formStaffMessage, setFormStaffMessage] = useState({
        id: 1,
        messageText: "",
    })

    const formStaffMessageChangeHandler = (e) => {
        setFormStaffMessage({
            ...formStaffMessage,
            [e.target.name]: e.target.value
        })
    }

    useEffect(() => {
        const setValidate = async () => {
            await setErrors(sendGroupMessageValidate(formStaffMessage))
        }
        setValidate()
    }, [formStaffMessage])

    // console.log(invitedPeople.map((item) => item.userId))

    return (
        <>

            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            <ToastContainer
                position="top-right"
                autoClose={8000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <div className='container-fluid'>
                <div className='row'>
                    <div className="col-md-9" >
                        <div className={`my-3 pb-4 px-0 ${styles.file_cards_container}`}>
                            <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                            <div
                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2"
                                dir="rtl"
                            >
                                <div className='d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                    <a href='#' onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                    <div className={styles.text1}>
                                        ارسال پیامک
                                    </div>
                                </div>
                            </div>

                            {/* Total Staff Managment Info */}

                            <StaffMessageSendTo InviteInput invitedPeople={invitedPeople} setInvitedPeople={setInvitedPeople} />

                            <StaffMessageForm
                                formStaffMessage={formStaffMessage}
                                formStaffMessageChangeHandler={formStaffMessageChangeHandler}
                                submitHandler={submitHandler}
                                btnLoader={btnLoader}
                            />

                        </div>
                    </div>
                    <div className='col-md-3'>
                        {/* sideMenu starts */}
                        <DashboardSideMenu managePersonal manageMessageSend />
                        {/* sideMenu ends */}
                    </div>
                </div>
            </div>
            {/* )} */}
        </>
    )

    function submitHandler() {
        if (!Object.keys(errors).length) {
            notify("درحال ارسال پیام", "success")
        } else {
            notify("!لطفا تمام فیلد هارا پرکنید", "error")
        }
    }

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            formSendHandler()
        } else if (type === "sentsuccess") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            // console.log(errors)
            setBtnLoader(false)
        }
        else {
            toast.error(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            // console.log(errors)
            setBtnLoader(false)
        }
    };

    async function formSendHandler() {
        const invitedsIDs = invitedPeople.map((item) => item.userId)
        setBtnLoader(true)
        var data = new FormData();
        for (const id of invitedsIDs) {
            data.append('UserIds', id?.toString());
            // console.log(id?.toString())
        }
        data.append('Content', formStaffMessage.messageText);

        const apiData = await axios.post(
            "GroupMessage/SendMessage",
            data,
            {
                headers: { authorization: "Bearer " + userToken },
            }
        );
        // console.log(apiData)
        if (apiData.data.isSuccess) {
            notify("پیام با موفقیقت ارسال شد", "sentsuccess")
        }
        setBtnLoader(false)
        // window.location.reload(false)
    }
}

export default StaffMessage;
